import {createAction} from "@reduxjs/toolkit";
import {InvoiceSearchCriteria} from "@ots-frontend/ots-data";

export const setUIInvoiceSearchFilter = createAction<InvoiceSearchCriteria>("ots-ui/invoice/setSearchFilter");
